import React from 'react';
import SkillBar from './SkillBar';

function Skills() {
    const frontendSkills = [
        { name: 'React', percentage: 90 },
        { name: 'Next.js', percentage: 95},
        { name: 'HTML5 & CSS3', percentage: 95 },
        { name: 'JavaScript & TypeScript', percentage: 90 },
        { name: 'Bootstrap ', percentage: 70 },
        { name: 'Tailwind css', percentage: 75}
    ];
   
    const backendSkills = [
        { name: 'ASP.NET Core', percentage: 95 },
        { name: 'SQL Server', percentage: 80 },
        { name: 'PostgreSQL', percentage: 85},
        { name: 'RESTful APIs', percentage: 85 },
        { name: 'NET Framework.', percentage: 80 }
    ];
   
    const otherTools = [
        'Git & GitHub', 'Entity Framework', 'Visual Studio','Responsive Design'
    ];
   
    return (
        <section id="skills" className="py-5">
            <div className="container py-5">
                <h2 className="text-center fw-bold section-title">مهاراتي التقنية</h2>
               
                <div className="row mt-5">
                    <div className="col-md-6 mb-4">
                        <h3 className="fw-bold mb-4">تقنيات وإطارات الواجهة الأمامية</h3>
                        {frontendSkills.map((skill, index) => (
                            <SkillBar key={index} name={skill.name} percentage={skill.percentage} />
                        ))}
                    </div>
                   
                    <div className="col-md-6 mb-4">
                        <h3 className="fw-bold mb-4">تقنيات الخادم والبيانات</h3>
                        {backendSkills.map((skill, index) => (
                            <SkillBar key={index} name={skill.name} percentage={skill.percentage} />
                        ))}
                    </div>
                </div>

                <div className="mt-5">
                    <h3 className="text-center fw-bold mb-4">أدوات وتقنيات أخرى</h3>
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                        {otherTools.map((tool, index) => (
                            <span key={index} className="badge bg-light text-dark p-2 px-3 fs-6">
                                {tool}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Skills;